import React from 'react';
import PropTypes from 'prop-types';
import { tileLayer } from 'leaflet';
import componentBase from '../../lib/component-base';

@componentBase('SatTileLayer')
export default class SatTileLayer extends React.Component {
  static propTypes = {
    map: PropTypes.object,
  };

  componentDidMount() {
    const satTileRoute = window.devicePixelRatio > 1 ? 'http://tiles{s}.flightstats.com/satellite/v2/{z}/{x}/{y}@2x.png' : 'http://tiles{s}.flightstats.com/satellite/v2/{z}/{x}/{y}.png';
    const satLayer = tileLayer(satTileRoute, {
      name: 'satellite',
      subdomains: '1234',
      zIndex: 2,
      minZoom: 2,
      maxZoom: 6,
      attribution: "<a id='attr-link' className='' alt='link to attributions list' href='/map-attributions'>Map licensing</a>",
    });

    const streetTileRoute = window.devicePixelRatio > 1 ? 'http://tiles{s}.flightstats.com/street/v2/{z}/{x}/{y}@2x.png' : 'http://tiles{s}.flightstats.com/street/v2/{z}/{x}/{y}.png';
    const streetLayer = tileLayer(streetTileRoute, {
      name: 'street',
      subdomains: '1234',
      zIndex: 1,
      minZoom: 7,
      maxZoom: 10,
    });

    this.props.map.addLayer(satLayer);
    this.props.map.addLayer(streetLayer);
  }

  render() {
    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./src/components/MapControlsAndLayers/SatTileLayer.js